import type { ModuleRoute } from '../types';
import { BuildingDetailPage } from './BuildingDetailPage';
import { BuildingsPage } from './BuildingsPage';

/** Pages of this area (shared reception, platform console: buildings list and detail, invitations, company order, building staff, devices and pairing codes, marshal phones, evacuation counts). Owned by shared reception task W-SR1; only that task edits files in this folder. */
export const routes: ModuleRoute[] = [
  { path: '/platform/shared-reception', element: <BuildingsPage />, permission: 'platform.shared_reception_view', area: 'platform' },
  { path: '/platform/shared-reception/:id', element: <BuildingDetailPage />, permission: 'platform.shared_reception_view', area: 'platform' },
];
